import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "assests/images";
import { BusinessPartnerForm } from "components";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";
import { IBusinessPartnerDetails, IValidationParms } from "utility/interfaces";
import { businessPartnerFormSchema } from "utility/validations";

const BusinessRequest: React.FC = () => {
  // Page level variables
  const navigate = useNavigate();

  // state variables
  const [businessDetails, setBusinessDetails] =
    useState<IBusinessPartnerDetails>({
      businessPartnerEmail: "",
      businessPartnerFirstName: "",
      businessPartnerLastName: "",
      businessPartnerPhoneNumber: "",
      isRequestorSMSOpted: false,
      businessPropertyName: "",
      radioRequestorPhoneType: "M",
      caseNumber: "",
      patientDetails: {
        symptoms: "",
        firstName: "",
        lastName: "",
        birthDate: "",
        email: "",
        phoneNumber: "",
        isPatientSMSOpted: false,
        radioClientPhoneType: "M",
        street: "",
        city: "",
        state: "",
        zipCode: "",
        room: "",
        document: "",
        documentName: "",
        clientRegionId: 0,
      },
    });

  // handle events and function
  const handleOnBackButtonClick = () => {
    navigate(AppRoutings.CreateRequest);
  };

  const onChangeBusinessDetails = (name: string, value: any) => {
    setBusinessDetails({ ...businessDetails, [name]: value });
  };

  // Yup resolver and validation
  const {
    register: businessPartnerFormRegister,
    handleSubmit: businessPartnerFormHandleSubmit,
    formState: { errors: businessPartnerFormErrors },
    reset: businessPartnerFormReset,
    clearErrors: businessPartnerFormClearErrors,
    setValue: businessPartnerFormSetValue,
    setError: businessPartnerFormSetError,
  } = useForm({
    reValidateMode: "onSubmit",
    values: businessDetails,
    resolver: yupResolver(businessPartnerFormSchema),
  });
  const businessPartnerFormValidation: IValidationParms = {
    register: businessPartnerFormRegister,
    handleSubmit: businessPartnerFormHandleSubmit,
    errors: businessPartnerFormErrors,
    reset: businessPartnerFormReset,
    clearErrors: businessPartnerFormClearErrors,
    setValue: businessPartnerFormSetValue,
    setError: businessPartnerFormSetError,
  };

  return (
    <>
      <main className="main-content">
        <div
          className="overlay"
          onClick={(e) => document.body.classList.toggle("sidebar-toggle")}
        ></div>

        <Box className="request-container-box">
          <div className="request-header">
            <div></div>
            <Button onClick={handleOnBackButtonClick} variant="outlined">
              <img src={ArrowBack} alt="arrow" />
              Back
            </Button>
          </div>

          <BusinessPartnerForm
            handleOnBackButtonClick={handleOnBackButtonClick}
            validationParams={businessPartnerFormValidation}
            details={businessDetails}
            onChangeDetails={onChangeBusinessDetails}
          />
        </Box>
      </main>
    </>
  );
};

export default BusinessRequest;
